import { render, staticRenderFns } from "./VideoUploadModal.vue?vue&type=template&id=e672f78e&scoped=true&"
import script from "./VideoUploadModal.vue?vue&type=script&lang=js&"
export * from "./VideoUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./VideoUploadModal.vue?vue&type=style&index=0&id=e672f78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e672f78e",
  null
  
)

export default component.exports